import React, { useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import defaultLightBoxCloseIcon from '../../../../public/SiteIcons/defaultLightBoxCloseIcon.svg';
import defaultLightBoxPrevArrow from '../../../../public/SiteIcons/defaultLightBoxPrevArrow.svg';
import defaultLightBoxNextArrow from '../../../../public/SiteIcons/defaultLightBoxNextArrow.svg';
import s from '../../../styles/customLightBoxSlider.css';

// Lightbox Component
const ImageSlider = ({ sources, closeImageLightBox, currentImage }) => {
  const [slideIndex, setSlideIndex] = useState(currentImage || 1);
  const [showLeftArrow, setLeftArrow] = useState(false);
  const [showRightArrow, setRightArrow] = useState(false);

  useEffect(() => {
    if (sources?.length > 0) {
      showSlides(currentImage >= 0 ? currentImage : 1);
      setLeftArrow(true);
      setRightArrow(true);
    }
    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeImageLightBox();
      }
    })
  });

  useEffect(() => {
    if (sources?.length > 0) {
      setSlideIndex(currentImage || 1);
    }
  }, [currentImage]);

  const plusSlides = (n) => {
    setSlideIndex((prev) => {
      let newSlideIndex = prev + n;
      if (newSlideIndex > sources?.length) newSlideIndex = 1;
      if (newSlideIndex < 1) newSlideIndex = sources?.length;
      return newSlideIndex;
    });
  };

  const currentSlide = (n) => {
    setSlideIndex(n);
    showSlides(n);
  };

  const showSlides = (n) => {
    var i;
    var slides = document.getElementsByClassName("customLightBoxImg");
    var dots = document.getElementsByClassName("singlePaginationImg");
    if (n > slides.length) { setSlideIndex(n) }
    if (n < 1) { setSlideIndex(slides.length) }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    if (slides[slideIndex - 1]) slides[slideIndex - 1]['style']['display'] = "block";
    if (dots[slideIndex - 1]) dots[slideIndex - 1]['className'] += " active";
  }

  const footerData = useMemo(() => {
    if (sources) {
      let imgLimit = 5;
      let imgGroup = Math.ceil(slideIndex / imgLimit);
      let sliceFrom = (imgGroup - 1) * imgLimit, sliceTo = (sliceFrom) + imgLimit;
      if (sources?.length > imgLimit && sources.slice(sliceFrom, sliceTo)?.length < imgLimit) {
        sliceFrom = sources?.length - imgLimit, sliceTo = sources?.length
      }
      return {
        imgIndex: sliceFrom, imgSrc: sources.slice(sliceFrom, sliceTo)
      }
    }
  }, [slideIndex, sources]);

  if (typeof window === "undefined" || !document?.body) return null;

  return createPortal(
    <div id="customImageBoxModal" className="customImgBoxModalWrapper">
      <div className="customImgBoxModalInnerWrapper">
        <div className="lightBoxImgNav">
          {showLeftArrow && <button className="imgBoxPrevBtn" onClick={() => plusSlides(-1)}>
            <img src={defaultLightBoxPrevArrow} alt="prevNav" />
          </button>}
          {showRightArrow && <button className="imgBoxNextBtn" onClick={() => plusSlides(1)}>
            <img src={defaultLightBoxNextArrow} alt="nextNav" />
          </button>}
        </div>
        <div>
          <div className="customImgBoxModalBody" >
            <div className="customLightBoxImgWrapper">
              <button className="customImgBoxModalClose" onClick={() => closeImageLightBox()}>
                <img src={defaultLightBoxCloseIcon} alt="close" />
              </button>
              {sources && sources?.length > 0 && sources?.map((item, index) => (
                <div
                  className={`customLightBoxImg ${index + 1 === slideIndex ? "active" : ""}`}
                  key={index}
                >
                  <img
                    src={item.src}
                  />
                  <p className="lightBoxImgCount">{`${index + 1} / ${sources?.length}`}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="customLightBoxPagination">
            {footerData?.imgSrc && footerData?.imgSrc?.map((item, index) => (
              <div className={cx("singlePaginationBox", ((footerData?.imgIndex + 1 + index) === slideIndex) && "singlePaginationBoxActive")}>
                <img
                  className="singlePaginationImg"
                  src={item.src}
                  onClick={() => currentSlide((footerData?.imgIndex + 1) + index)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>, document.body
  );
};

export default withStyles(s)(ImageSlider);